import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { PartNumberModel, PartsListViewModel } from 'projects/Administration/src/app/business-entities/parts-list-view-model';
import { PartsBusinessService } from 'projects/Administration/src/app/business-services/parts.service';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { CookieService } from 'ngx-cookie-service';
import { CultureLocaleService } from 'projects/Administration/src/app/services/culture-locale.service';

@Component({
  selector: 'app-search-replacement-parts',
  templateUrl: './search-replacement-parts.component.html'
})
export class SearchReplacementPartsComponent implements OnInit {
  selectedPart: PartsListViewModel =
    {
      partNumber: "",
      makeCode: "",
      locationCode: '',
      locationName: '',
      description: '',
      unitPrice: 0,
      unitPriceInclVat: 0,
      quantity: 0,
      availableQuantity: 0,
      tenantId:''
    };
  replacedPartsList: PartsListViewModel[] = [];
  modalAlterRef: NgbModalRef;
  partModel: PartNumberModel;
  constructor(
    public partService: PartsBusinessService,
    private activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    private translate: TranslateService,
    private cookieservice: CookieService,
    public cultureLocaleService: CultureLocaleService
    ) { }

    ngOnInit(): void {
      if (!this.empty(this.partService.searchPartNumber)) {
        this.getPartDetails();
      }
    }
    async getPartDetails() {
      this.partService.partNumberModel = [];
      this.partModel = { partNumber: this.partService.searchPartNumber };
      this.partService.partNumberModel.push(this.partModel);
      let model = {
        locationCode: this.partService.locationCode,
        partNumberModel: this.partService.partNumberModel,
        languageCode:this.cookieservice.get('userSelectedLanguage')
      }
      this.spinner.show();
     await this.partService.GetPartDetails(model).then(response => {
        this.spinner.hide();
        if (response.length > 0) {
          this.selectedPart = response[0];
           this.getReplacementParts();
        }
      });
    }

    async getReplacementParts() {
      let model = {
        locationCode: this.partService.locationCode,
        no: this.selectedPart.partNumber,
        languageCode:this.cookieservice.get('userSelectedLanguage')
      }
      this.spinner.show();
      await this.partService.GetReplacementParts(model).then(response => {
        this.replacedPartsList = this.PartDataMapper(response);
        this.spinner.hide();
      }, _error => {
        this.spinner.hide();
      });
    }

    private PartDataMapper(service: PartsListViewModel[]) {
      let supperArray = [];
      if (service && service.length > 0) {
        service.forEach(element=>{ 
          const single = Object();
          single.id = element.id;
          single.partNumber = element.partNumber;
          single.costType = element.costType;
          single.description = element.description;
          single.unitPrice = element.unitPrice;
          single.baseUnitofMeasure = element.baseUnitofMeasure;
          single.unitCost = element.unitCost;
          single.unitPriceInclVat = element.unitPriceInclVat;
          single.makeCode = element.makeCode;
          single.quantity = element.quantity;
          single.locationCode = element.locationCode;
          single.availableQuantity = element.availableQuantity;
          single.locationName = element.locationName;
          single.hasAdditionalItems = element.hasAdditionalItems;
          single.hasAlternativeItems = element.hasAlternativeItems;
          single.hasReplacementItems = element.hasReplacementItems;
          single.itemGroupCode = element.itemGroupCode;
          single.lastDirectCost = element.lastDirectCost;
          single.listPriceLCY = element.listPriceLCY;
          single.qty = 0;
          single.isPartSelected = false;
          single.expanded = false;
          single.partLocationList = [];
          supperArray.push(single);
        })
      }
      return supperArray;
    }

    async onSaveReplaceItems() {
      let record = this.replacedPartsList.filter(x => x.isPartSelected);
      if (record.length == 0) {
        let ServiceNotFound = this.translate.instant("lblRequiredPartSelect");
        this.toaster.error(ServiceNotFound);
        return;
      }
      this.spinner.show();
      this.partService.selectedPartListWithAddtionalItems = [];
      let model = {
        locationCode: this.partService.locationCode,
        parts: record,
        languageCode:this.cookieservice.get('userSelectedLanguage')
      }
      await this.partService.GetFinalPartsWithAdditional(model).then(response => {
        this.spinner.hide();
        this.partService.selectedPartListWithAddtionalItems = response;
      });
      this.activeModal.dismiss(true);
    }

    OnClose() {
      this.partService.selectedPartListWithAddtionalItems = [];
      this.partService.searchPartNumber = '';
      this.activeModal.dismiss(false);
    }
    async getPartLocation(no_: any, i: number) {
      if (this.replacedPartsList[i].expanded) {
        return;
      }
      this.spinner.show();
      let model = {
        locationCode: this.partService.locationCode,
        no: no_,
        languageCode:this.cookieservice.get('userSelectedLanguage')
      }
      await this.partService.GetPartLocation(model).then(response => {
        this.replacedPartsList[i].partLocationList = response;
        this.spinner.hide();
      }, _error => {
        this.spinner.hide();
      });
    }

    empty(e: any) {
      switch (e) {
        case "":
        case null:
        case undefined:
          return true;
        default:
          return false;
      }
    }
    numberEmpty(e: any) {
      switch (e) {
        case "":
        case null:
        case undefined:
        case "0":
        case 0:
          return true;
        default:
          return false;
      }
    }
    isDigit(event): void {
      const isDigit = Utility.isDigit(event);
      if (!isDigit) {
        event.preventDefault();
      }
    }
    isQtyPrice(event, value) {
      if (!this.cultureLocaleService.isQtyPrice(event, value)) {
        let msg = this.translate.instant("lblValidValue");
        this.toaster.error(msg)
        event.preventDefault();
      }
    }
    checkReplaceQty(e, i) {
      if (this.empty(e)) {
        e = 0;
      }
      if (this.replacedPartsList[i].availableQuantity > 0) {
        if (this.replacedPartsList[i].availableQuantity < e) {
          let errorMessage = this.translate.instant("lblQuantityValidation");
          this.toaster.error(errorMessage);
          this.replacedPartsList[i].qty = 0;
        }
        else if (e == 0) {
          let errorMessage = this.translate.instant("lblMinQuantity");
          this.toaster.error(errorMessage);
          this.replacedPartsList[i].qty = 0;
        }
        else {
          this.replacedPartsList[i].qty = Number(e.toString().replace(',', '.'));
        }
      } else {
        this.replacedPartsList[i].qty = Number(e.toString().replace(',', '.'));
      }
    }

}
